import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'unicon-user-chip',
  templateUrl: './user-chip.component.html',
})
export class UserChipComponent implements OnInit {
  protected initials: string = '';
  @Input() user?: string;

  ngOnInit(): void {
    this.setBadgeText();
  }

  private setBadgeText(): void {
    if (this.user) {
      const slices: string[] = this.user.split(' ');
      this.initials = slices[0][0] + (slices[1] ? slices[1][0] : '');
    }
  }
}
